module.exports = __webpack_public_path__ + "img/badge-ad.690bc497.svg";